import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { getLocale } from '@app/i18n';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexDirection: 'row',
    marginBottom: theme.marginBase * 2,
  },
  title: {
    ...theme.fonts.h2,
  },
  title2: {
    ...theme.fonts.h2,
    paddingRight: theme.marginBase,
  },
  reduceTitle: {
    fontSize: 28,
  },
  timezone: {
    ...theme.fonts.h2,
    fontSize: 22,
    fontWeight: 700,
    alignSelf: 'flex-end',
    lineHeight: '156%',
  },
  reduceTimezone: {
    fontSize: 20,
    lineHeight: '140%',
  },
  round: {
    margin: [0, theme.marginBase],
    width: 4,
    height: 4,
    backgroundColor: theme.colors.white,
    borderRadius: '50%',
  },
  roundGreen: {
    backgroundColor: theme.colors.greenAccessible,
  },
}));

interface Props {
  date: Date;
  timeZone?: string;
  focus?: boolean;
}

export const DisplayDate = ({ date, timeZone, focus = false }: Props) => {
  const { i18n } = useTranslation();
  const classes = useStyles();

  const timeZoneListString: string[] = Intl.DateTimeFormat(getLocale(i18n), {
    day: 'numeric',
    timeZoneName: 'shortGeneric',
    timeZone: timeZone,
  })
    .format(date)
    .split(' ');
  timeZoneListString.shift();
  const timeZoneString = timeZoneListString.join(' ');

  return (
    <div className={classes.container}>
      <h1
        className={classnames(classes.title, { [classes.reduceTitle]: !focus })}
      >
        {Intl.DateTimeFormat(getLocale(i18n), {
          day: '2-digit',
          month: 'short',
          timeZone: timeZone,
        }).format(date)}
      </h1>
      <div
        className={classnames(classes.round, { [classes.roundGreen]: !focus })}
      />
      <h1
        className={classnames(classes.title2, {
          [classes.reduceTitle]: !focus,
        })}
      >
        {Intl.DateTimeFormat(getLocale(i18n), {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: timeZone,
        }).format(date)}
      </h1>
      {timeZone && (
        <h2
          className={classnames(classes.timezone, {
            [classes.reduceTimezone]: !focus,
          })}
        >
          {timeZoneString}
        </h2>
      )}
    </div>
  );
};
